export default __webpack_public_path__ + "static/media/category_de.466e856e.svg";